import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import automationsReducer from "./slices/automationsSlice";
import credentialsReducer from "./slices/credentialsSlice";
import uiReducer from "./slices/uiSlice";
import authReducer from "./slices/authSlice";
import schedulesReducer from "./slices/schedulesSlice";
import appRegistryReducer from "./slices/appRegistrySlice";
import extensionScriptsReducer from "./slices/extensionScriptsSlice";
import networkRulesReducer from "./slices/networkRulesSlice";
import clientsReducer from "./slices/clientsSlice";
import emailInterceptReducer from "./slices/emailInterceptSlice";
import elementHiderReducer from "./slices/elementHiderSlice";
import networkMonitorReducer from "./slices/networkMonitorSlice";
import filterSimulatorReducer from "./slices/filterSimulatorSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    automations: automationsReducer,
    credentials: credentialsReducer,
    ui: uiReducer,
    schedules: schedulesReducer,
    appRegistry: appRegistryReducer,
    extensionScripts: extensionScriptsReducer,
    networkRules: networkRulesReducer,
    clients: clientsReducer,
    emailIntercept: emailInterceptReducer,
    elementHider: elementHiderReducer,
    networkMonitor: networkMonitorReducer,
    filterSimulator: filterSimulatorReducer,
  },
  middleware: getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: ["automations/fetchAutomationsSuccess", "schedules/fetchAll/rejected"],
      ignoredActionPaths: ["payload.createdAt", "payload.updatedAt", "payload.lastRunAt", "payload.nextScheduledAt"],
      ignoredPaths: [
        "automations.automations.createdAt",
        "automations.automations.updatedAt",
        "automations.automations.lastRunAt",
        "schedules.schedules.createdAt",
        "schedules.schedules.updatedAt",
        "schedules.schedules.nextScheduledAt",
        "schedules.schedules.lastScheduledAt"
      ],
    },
  }),
});

export default store;
